import { render, staticRenderFns } from "./external.vue?vue&type=template&id=5ba7efa3&"
import script from "./external.vue?vue&type=script&lang=js&"
export * from "./external.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports